/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { ConfigProvider, Button } from 'antd';
import axios from 'axios';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const login = async () => {
  try {
    const res = await axios.post('http://api_02.ddspp.com:30123/a_device/v2_date_batchsb',

      {
        merchant_id: '1000',
        "fu": "test01",
        token: "1000_2ea24c03a81bf5160e93dc39ec7a6a3c",
        psw_md5: 'e10adc3949ba59abbe56e057f20f883e',
        pdate:'2026年9月16日',
        batch_no:"ABSCUJEI",
        code_urls:[
          "http://ddspp.cn/S/18676102100155954512284624814819",
          "http://ddspp.cn/S/18676102100155954612284624897141",
          "http://ddspp.cn/u/?q=18676102100216700712284624713551",
          "http://ddspp.cn/u/?q=18676102100216700812284624716007",

        ]
      }
      // , {
      //   headers: {
      //     Authorization: '{"fu":"test01","merchant_id":"1000","token":"1000_2ea24c03a81bf5160e93dc39ec7a6a3c"}'
      //   }
      // }

    );
    console.log(res.data);
  } catch (err) {
    console.error(err);
  }
};

// "{\"fu\":\"test01\",\"merchant_id\":\"1000\",\"token\":\"1000_2ea24c03a81bf5160e93dc39ec7a6a3c\"}"

const Test4 = () => {







  return (<ConfigProvider locale={zhCN} >

    <Button onClick={() => login()}
    >
      aaaaa
    </Button>


  </ConfigProvider>

  );
};
export default Test4;